import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: 'img[appFallbackImg]',
    standalone: false
})
export class FallbackImgDirective {
  @Input() appFallbackImg!: string;

  constructor(private el: ElementRef<HTMLImageElement>) {}

  @HostListener('error')
  onError() {
    const element = this.el.nativeElement;
    if (element.src !== this.appFallbackImg) {
      element.src = this.appFallbackImg;
    }
  }
}
